const _ = "";
export {
  _ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/guahuabihua/guahuabihua.vue3.js
// module id = 1213
// module chunks = 41